// import React, { useState, useEffect, useRef } from 'react';
// import { ChevronLeft, Zap, Camera, Loader } from 'lucide-react';
// import blurTop from '../../assets/splashScreen/Blur.svg'
// import kyc from '../../assets/splashScreen/Group 714.svg'
// import { useNavigate } from 'react-router-dom';


// import React, { useState, useEffect, useRef } from "react";
// import { ChevronLeft, Zap } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { Capacitor } from "@capacitor/core";
// import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";


// // --- 1. Live Selfie Capture Screen Component (Updated View) ---

// const SelfieCaptureScreen = ({ onBack, onCapture }) => {

//     const navigate = useNavigate()
//     const videoRef = useRef(null);
//     const [streamStatus, setStreamStatus] = useState('Loading camera...');
//     const [isCameraActive, setIsCameraActive] = useState(false);
//     const [error, setError] = useState(null);
//     // Use a ref to hold the stream object for cleanup
//     const streamRef = useRef(null); 

//     useEffect(() => {
//         const startCamera = async () => {

//             // --- FIX: Check for navigator.mediaDevices existence before calling getUserMedia ---
//             if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//                 setError('Camera API is not supported in this environment or requires a secure connection (HTTPS).');
//                 setStreamStatus('Error');
//                 return;
//             }
//             // --- END FIX ---

//             try {
//                 // Request user-facing camera
//                 const newStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } });
//                 streamRef.current = newStream; // Store stream in ref for cleanup

//                 if (videoRef.current) {
//                     videoRef.current.srcObject = newStream;

//                     videoRef.current.onloadedmetadata = () => {
//                         videoRef.current.play();
//                         setStreamStatus('Ready');
//                         setIsCameraActive(true);
//                         setError(null);
//                     };
//                 }
//             } catch (err) {
//                 console.error("Error accessing camera:", err);
//                 setIsCameraActive(false);
//                 if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
//                     setError('Camera access denied. Please grant permissions to your browser/device.');
//                 } else if (err.name === "NotFoundError") {
//                     setError('No camera found on this device.');
//                 } else {
//                     setError(`Error starting camera: ${err.message}.`);
//                 }
//                 setStreamStatus('Error');
//             }
//         };

//         startCamera();

//         // Cleanup: stop tracks when component unmounts
//         return () => {
//             if (streamRef.current) {
//                 streamRef.current.getTracks().forEach(track => track.stop());
//                 streamRef.current = null;
//             }
//         };
//     }, []);

//     const handleCapture = () => {
//         if (!videoRef.current || !isCameraActive) {
//             alert("Camera is not active. Cannot capture photo.");
//             return;
//         }

//         // 1. Create a hidden canvas element to draw the frame
//         const canvas = document.createElement('canvas');
//         canvas.width = videoRef.current.videoWidth;
//         canvas.height = videoRef.current.videoHeight;

//         // 2. Draw the current video frame onto the canvas
//         const ctx = canvas.getContext('2d');
//         ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

//         // 3. Get the image data URL
//         const imageDataUrl = canvas.toDataURL('image/jpeg');

//         // 4. Simulate sending the captured image
//         // IMPORTANT: Use a non-alert message box in a real application
//         alert("Selfie captured! Data logged to console.");
//         console.log("Captured Selfie Data URL (Base64, truncated):", imageDataUrl.substring(0, 50) + "...");

//         // 5. Call the parent handler to complete the step
//         onCapture(imageDataUrl); 
//     };

//     return (
//         <div className="fixed inset-0 bg-black flex flex-col z-50 overflow-hidden">
//             {/* Camera Feed Container */}
//             <div className="absolute inset-0">
//                 <video 
//                     ref={videoRef}
//                     className="w-full h-full object-cover" 
//                     autoPlay 
//                     playsInline 
//                     // Only show the video element if the camera is deemed active
//                     style={{ display: isCameraActive ? 'block' : 'none' }}
//                 />

//                 {/* Loading/Error Overlay */}
//                 {!isCameraActive && (
//                     <div className="absolute inset-0 bg-gray-900 flex flex-col items-center justify-center p-8 text-center">
//                         {error ? (
//                             <div className="text-red-400">
//                                 <Zap className="w-12 h-12 mb-4 mx-auto" />
//                                 <h3 className="font-bold text-lg mb-2">Camera Error</h3>
//                                 <p className="text-sm text-red-300">{error}</p>
//                             </div>
//                         ) : (
//                             <div className="text-white">
//                                 <Loader className="w-12 h-12 mb-4 mx-auto animate-spin" />
//                                 <p>{streamStatus}</p>
//                             </div>
//                         )}
//                     </div>
//                 )}
//             </div>

//             {/* Header: Back Button (White/Light) and Flash Icon */}
//             <div className="p-4 flex justify-between items-center z-10 relative">
//                 <ChevronLeft className="w-8 h-8 text-white cursor-pointer drop-shadow-lg" onClick={()=>{
//                     navigate('/kycid')
//                 }} />
//                 <Zap className="w-6 h-6 text-white cursor-pointer opacity-70 drop-shadow-lg" />
//             </div>

//             {/* Face Alignment Guides (Bounding Box) */}
//             <div className="flex-1 flex justify-center items-center p-8 relative z-10">
//                 <div className="w-full h-full max-w-sm max-h-[80vh] relative">
//                     {/* Corner Guides */}
//                     <div 
//                         className="absolute inset-0 border-white/50 border-4 border-dashed rounded-xl" 
//                         style={{ 
//                             clipPath: 'polygon(0 0, 0% 15%, 15% 15%, 15% 0, 0 0, 0 85%, 0 100%, 15% 100%, 15% 85%, 0 85%, 85% 85%, 85% 100%, 100% 100%, 100% 85%, 100% 0, 85% 0, 85% 15%, 100% 15%)', 
//                             opacity: 0.8 
//                         }} 
//                     />
//                     <div className="absolute inset-0 flex flex-col justify-center items-center">
//                         {/* Instruction inside the frame */}
//                         <p className="text-white text-sm font-medium mt-[-10vh]">Center your face</p>
//                     </div>
//                 </div>
//             </div>

//             {/* Bottom Controls and Instructions */}
//             <div className="p-8 pb-10 bg-gradient-to-t from-black/80 to-transparent flex flex-col items-center relative z-10">
//                 {/* Instruction Text */}
//                 <div className="text-center mb-8">
//                     <h2 className="text-xl font-bold text-white mb-1 drop-shadow-md">Align your face in the middle</h2>
//                     <p className="text-sm text-gray-300 drop-shadow-md">Make sure your face is clearly visible inside the box</p>
//                 </div>

//                 {/* Capture Button */}
//                 <button
//                     className={`w-20 h-20 bg-white rounded-full border-4 border-gray-400/50 flex items-center justify-center shadow-2xl transition-transform ${isCameraActive ? 'hover:scale-105' : 'opacity-50 cursor-not-allowed'}`}
//                     onClick={handleCapture}
//                     disabled={!isCameraActive}
//                 >
//                     {/* Inner circle (shutter button design) */}
//                     <div className="w-16 h-16 bg-white rounded-full border-2 border-gray-200"></div>
//                 </button>
//             </div>
//         </div>
//     );
// };


// --use old --
// const SelfieCaptureScreen = ({ onCapture }) => {
//     const navigate = useNavigate();
//     const videoRef = useRef(null);
//     const [streamStatus, setStreamStatus] = useState('Loading camera...');
//     const [isCameraActive, setIsCameraActive] = useState(false);
//     const [error, setError] = useState(null);
//     const [isSimulated, setIsSimulated] = useState(false);
//     const [flash, setFlash] = useState(false);       // <-- NEW for flash effect
//     const streamRef = useRef(null);

//     /* ------------------ Flash animation ------------------ */
//     const triggerFlash = () => {
//         setFlash(true);
//         setTimeout(() => setFlash(false), 200); // fade out
//     };

//     /* ------------------ Camera handling ------------------ */
//     useEffect(() => {
//         const startCamera = async () => {
//             if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//                 setError('Camera API unavailable.');
//                 setStreamStatus('Error');
//                 return;
//             }

//             try {
//                 const newStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } });
//                 streamRef.current = newStream;

//                 if (videoRef.current) {
//                     videoRef.current.srcObject = newStream;
//                     videoRef.current.onloadedmetadata = () => {
//                         videoRef.current.play();
//                         setStreamStatus('Ready');
//                         setIsCameraActive(true);
//                         setError(null);
//                     };
//                 }
//             } catch (err) {
//                 const secure = window.location.protocol === 'https:' || window.location.hostname === 'localhost';
//                 if (!secure) {
//                     setIsSimulated(true);
//                     setStreamStatus('Simulated Stream');
//                     setIsCameraActive(true);
//                     setError("Camera allowed only on HTTPS — UI Simulation Mode ON");
//                 } else {
//                     setIsCameraActive(false);
//                     setError(err.message);
//                 }
//             }
//         };

//         startCamera();

//         return () => {
//             if (streamRef.current) {
//                 streamRef.current.getTracks().forEach(t => t.stop());
//                 streamRef.current = null;
//             }
//         };
//     }, []);

//     /* ------------------ Capture Handler ------------------ */
//     const handleCapture = () => {
//         if (!isCameraActive) return alert("Camera inactive");

//         triggerFlash();   // <-- FLASH ON CAPTURE

//         if (isSimulated) {
//             setTimeout(() => {
//                 onCapture("simulated-image-url");
//             }, 400);
//             return;
//         }

//         const canvas = document.createElement('canvas');
//         canvas.width = videoRef.current.videoWidth;
//         canvas.height = videoRef.current.videoHeight;

//         const ctx = canvas.getContext('2d');
//         ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

//         const dataURL = canvas.toDataURL('image/jpeg');
//         onCapture(dataURL);
//     };

//     /* ------------------------------------------------------ */

//     return (
//         <div className="fixed inset-0 bg-black flex flex-col z-50 overflow-hidden">

//             {/* FLASH OVERLAY */}
//             {flash && (
//                 <div className="absolute inset-0 bg-white animate-pulse opacity-70 pointer-events-none"></div>
//             )}

//             {/* Camera */}
//             <div className="absolute inset-0">
//                 <video
//                     ref={videoRef}
//                     className="w-full h-full object-cover"
//                     autoPlay
//                     playsInline
//                     style={{ transform: 'scaleX(-1)', display: !isSimulated ? 'block' : 'none' }}
//                 />

//                 {isSimulated && (
//                     <div className="w-full h-full flex items-center justify-center bg-gray-900/60">
//                         <div className="text-gray-300">Simulated Camera Feed</div>
//                     </div>
//                 )}
//             </div>

//             {/* BACK BUTTON */}
//             <div className="pt-4 px-4 flex justify-start z-10">
//                 <ChevronLeft
//                     className="w-8 h-8 text-white cursor-pointer"
//                     onClick={() => navigate('/kycid')}
//                 />
//             </div>

//             {/* SCANNER FRAME */}
//             <div className="flex-1 flex justify-center items-center relative z-10">
//                 <div className="relative w-[80vw] h-[85vw] max-w-[350px] max-h-[400px]">

//                     {/* VERY LIGHT FAINT BORDER */}
//                     <div className="absolute inset-0 border border-white/20 rounded-xl"></div>

//                     {/* 4 CORNER BRACKETS (FULL WHITE) */}
//                     <div className="absolute top-0 left-0 w-10 h-10 border-t-4 border-l-4 border-white rounded-tl-xl"></div>
//                     <div className="absolute top-0 right-0 w-10 h-10 border-t-4 border-r-4 border-white rounded-tr-xl"></div>
//                     <div className="absolute bottom-0 left-0 w-10 h-10 border-b-4 border-l-4 border-white rounded-bl-xl"></div>
//                     <div className="absolute bottom-0 right-0 w-10 h-10 border-b-4 border-r-4 border-white rounded-br-xl"></div>
//                 </div>
//             </div>

//             {/* BOTTOM AREA */}
//             <div className="px-8 pb-12 bg-gradient-to-t from-black/90 to-transparent text-center z-10">

//              <p className="text-xl font-semibold text-white mb-2 drop-shadow-lg">Align your face in the middle</p> <p className="text-sm text-gray-300 drop-shadow-md">Make your face is inside the box and capture a photo</p>

//                 <div className="relative flex justify-center items-center mt-12">

//                     {/* Capture Button */}
//                     <button
//                         className={`w-16 h-16 bg-white rounded-full border-4 border-gray-400/40 flex items-center justify-center shadow-xl transition-transform ${isCameraActive ? "hover:scale-105" : "opacity-40"}`}
//                         onClick={handleCapture}
//                         disabled={!isCameraActive}
//                     >
//                         <div className="w-12 h-12 bg-white rounded-full border border-gray-200"></div>
//                     </button>

//                     {/* Flash icon */}
//                     <div className="absolute right-0">
//                         <Zap
//                             onClick={triggerFlash}
//                             className="w-7 h-7 text-white cursor-pointer hover:text-yellow-300 transition"
//                         />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SelfieCaptureScreen;


// -----new test1---

// const SelfieCaptureScreen = ({ onCapture }) => {
//   const navigate = useNavigate();
//   const videoRef = useRef(null);
//   const [isCameraActive, setIsCameraActive] = useState(false);
//   const [flash, setFlash] = useState(false);
//   const [error, setError] = useState(null);
//   const [isWeb, setIsWeb] = useState(true);
//   const streamRef = useRef(null);

//   /* ------------------ Flash Animation ------------------ */
//   const triggerFlash = () => {
//     setFlash(true);
//     setTimeout(() => setFlash(false), 200);
//   };

//   /* ------------------ Camera Init ------------------ */
//   useEffect(() => {
//     const initCamera = async () => {
//       // Detect if running in web or Capacitor
//       const runningWeb = Capacitor.getPlatform() === "web";
//       setIsWeb(runningWeb);

//       if (runningWeb) {
//         // Web/PWA: Use getUserMedia
//         if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//           setError("Camera not supported in this browser.");
//           return;
//         }

//         try {
//           const stream = await navigator.mediaDevices.getUserMedia({
//             video: { facingMode: "user" },
//           });
//           streamRef.current = stream;

//           if (videoRef.current) {
//             videoRef.current.srcObject = stream;
//             videoRef.current.onloadedmetadata = () => {
//               videoRef.current.play();
//               setIsCameraActive(true);
//               setError(null);
//             };
//           }
//         } catch (err) {
//           console.error("Web camera error:", err);
//           setError("Cannot access camera.");
//         }
//       } else {
//         // APK/Capacitor: no video element needed
//         setIsCameraActive(true);
//       }
//     };

//     initCamera();

//     return () => {
//       // Cleanup tracks for web
//       if (streamRef.current) {
//         streamRef.current.getTracks().forEach((t) => t.stop());
//         streamRef.current = null;
//       }
//     };
//   }, []);

//   /* ------------------ Capture Handler ------------------ */
//   const handleCapture = async () => {
//     triggerFlash();

//     // if (isWeb) {
//     //   // Web: capture from video element
//     //   if (!videoRef.current || !isCameraActive) return alert("Camera inactive");
//     //   const canvas = document.createElement("canvas");
//     //   canvas.width = videoRef.current.videoWidth;
//     //   canvas.height = videoRef.current.videoHeight;
//     //   const ctx = canvas.getContext("2d");
//     //   ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
//     //   const dataURL = canvas.toDataURL("image/jpeg");
//     //   onCapture(dataURL);
//     // }
//     if (!isWeb) {
//   const granted = await requestCameraPermission();
//   if (!granted) return;

//   try {
//     const photo = await Camera.getPhoto({
//       quality: 90,
//       resultType: CameraResultType.DataUrl,
//       correctOrientation: true,
//       source: "camera",       // 👈 this FORCES camera, no prompt
//       saveToGallery: false,
//     });

//     onCapture(photo.dataUrl);
//   } catch (err) {
//     console.error("Capacitor camera error:", err);
//     setError("Cannot access camera in app.");
//   }
// }
//  else {
//       // APK: use Capacitor Camera Plugin
//       try {
//        const photo = await Camera.getPhoto({
//   quality: 90,
//   resultType: CameraResultType.DataUrl,
//   correctOrientation: true,
// });

//         onCapture(photo.dataUrl);
//       } catch (err) {
//         console.error("Capacitor camera error:", err);
//         setError("Cannot access camera in app.");
//       }
//     }
//   };


//   const requestCameraPermission = async () => {
//   try {
//     const status = await Camera.requestPermissions();
//     console.log("Permission status:", status);

//     if (status.camera !== "granted") {
//       setError("Camera permission not granted.");
//       return false;
//     }

//     return true;
//   } catch (err) {
//     console.error("Permission error:", err);
//     setError("Failed to request camera permission.");
//     return false;
//   }
// };
//   /* ------------------ Render ------------------ */
//   return (
//     <div className="fixed inset-0 bg-black flex flex-col z-50 overflow-hidden">
//       {/* Flash overlay */}
//       {flash && (
//         <div className="absolute inset-0 bg-white animate-pulse opacity-70 pointer-events-none" />
//       )}

//       {/* Web Video */}
//       {isWeb && (
//         <video
//           ref={videoRef}
//           className="w-full h-full object-cover"
//           autoPlay
//           playsInline
//           style={{ transform: "scaleX(-1)" }}
//         />
//       )}

//       {/* Error Overlay */}
//       {error && (
//         <div className="absolute inset-0 flex items-center justify-center bg-gray-900/80 text-white text-center p-4">
//           {error}
//         </div>
//       )}

//       {/* Back Button */}
//       <div className="pt-4 px-4 flex justify-start z-10">
//         <ChevronLeft
//           className="w-8 h-8 text-white cursor-pointer"
//           onClick={() => navigate("/kycid")}
//         />
//       </div>

//       {/* Face Alignment Frame */}
//       <div className="flex-1 flex justify-center items-center relative z-10">
//         <div className="relative w-[80vw] h-[85vw] max-w-[350px] max-h-[400px]">
//           <div className="absolute inset-0 border border-white/20 rounded-xl"></div>
//           <div className="absolute top-0 left-0 w-10 h-10 border-t-4 border-l-4 border-white rounded-tl-xl"></div>
//           <div className="absolute top-0 right-0 w-10 h-10 border-t-4 border-r-4 border-white rounded-tr-xl"></div>
//           <div className="absolute bottom-0 left-0 w-10 h-10 border-b-4 border-l-4 border-white rounded-bl-xl"></div>
//           <div className="absolute bottom-0 right-0 w-10 h-10 border-b-4 border-r-4 border-white rounded-br-xl"></div>
//         </div>
//       </div>

//       {/* Bottom Controls */}
//       <div className="px-8 pb-12 bg-gradient-to-t from-black/90 to-transparent text-center z-10">
//         <p className="text-xl font-semibold text-white mb-2 drop-shadow-lg">
//           Align your face in the middle
//         </p>
//         <p className="text-sm text-gray-300 drop-shadow-md">
//           Make sure your face is inside the box and capture a photo
//         </p>

//         <div className="relative flex justify-center items-center mt-12">
//           <button
//             className={`w-16 h-16 bg-white rounded-full border-4 border-gray-400/40 flex items-center justify-center shadow-xl transition-transform ${
//               isCameraActive ? "hover:scale-105" : "opacity-40"
//             }`}
//             onClick={handleCapture}
//             disabled={!isCameraActive}
//           >
//             <div className="w-12 h-12 bg-white rounded-full border border-gray-200"></div>
//           </button>

//           <div className="absolute right-0">
//             <Zap
//               onClick={triggerFlash}
//               className="w-7 h-7 text-white cursor-pointer hover:text-yellow-300 transition"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SelfieCaptureScreen;

// const SelfieCaptureScreen = ({ onCapture }) => {
//     const navigate = useNavigate();

//     const videoRef = useRef(null);
//     const streamRef = useRef(null);

//     const [isCameraActive, setIsCameraActive] = useState(false);
//     const [isWeb, setIsWeb] = useState(true);
//     const [error, setError] = useState(null);
//     const [flash, setFlash] = useState(false);

//     /* ------------------ Flash animation ------------------ */
//     const triggerFlash = () => {
//         setFlash(true);
//         setTimeout(() => setFlash(false), 200);
//     };

//     /* ------------------ Permission (Android APK) ------------------ */
//     const requestCameraPermission = async () => {
//         try {
//             const status = await Camera.requestPermissions();
//             if (status.camera !== "granted") {
//                 setError("Camera permission not granted.");
//                 return false;
//             }
//             return true;
//         } catch (err) {
//             setError("Failed to request camera permission.");
//             return false;
//         }
//     };

//     /* ------------------ Init Camera (Web + APK) ------------------ */
//     useEffect(() => {
//         const initCamera = async () => {
//             const runningWeb = Capacitor.getPlatform() === "web";
//             setIsWeb(runningWeb);

//             /* ---------- APK (no video preview needed) ---------- */
//             if (!runningWeb) {
//                 setIsCameraActive(true);
//                 return;
//             }

//             /* ---------- WEB Camera ---------- */
//             if (!navigator.mediaDevices?.getUserMedia) {
//                 setError("Camera not supported in browser.");
//                 return;
//             }

//             try {
//                 const stream = await navigator.mediaDevices.getUserMedia({
//                     video: { facingMode: "user" }
//                 });

//                 streamRef.current = stream;

//                 if (videoRef.current) {
//                     videoRef.current.srcObject = stream;
//                     videoRef.current.onloadedmetadata = () => {
//                         videoRef.current.play();
//                         setIsCameraActive(true);
//                     };
//                 }

//             } catch (err) {
//                 setError("Cannot access web camera.");
//             }
//         };

//         initCamera();

//         return () => {
//             if (streamRef.current) {
//                 streamRef.current.getTracks().forEach(t => t.stop());
//                 streamRef.current = null;
//             }
//         };
//     }, []);

//     /* ------------------ Capture Handler ------------------ */
//     const handleCapture = async () => {
//         if (!isCameraActive) return;

//         triggerFlash();

//         /* -------- WEB CAPTURE (canvas) -------- */
//         if (isWeb) {
//             const canvas = document.createElement("canvas");
//             canvas.width = videoRef.current.videoWidth;
//             canvas.height = videoRef.current.videoHeight;

//             const ctx = canvas.getContext("2d");
//             ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

//             const dataURL = canvas.toDataURL("image/jpeg");
//             onCapture(dataURL);
//             return;
//         }

//         /* -------- ANDROID CAPACITOR CAMERA -------- */
//         const granted = await requestCameraPermission();
//         if (!granted) return;

//         try {
//             const photo = await Camera.getPhoto({
//                 quality: 90,
//                 resultType: CameraResultType.DataUrl,
//                 source: CameraSource.Camera,
//                 correctOrientation: true,
//                 saveToGallery: false
//             });

//             onCapture(photo.dataUrl);

//         } catch (err) {
//             setError("Cannot capture from app camera.");
//         }
//     };

//     /* ------------------ UI (unchanged) ------------------ */
//     return (
//         <div className="fixed inset-0 bg-black flex flex-col z-50 overflow-hidden">

//             {flash && (
//                 <div className="absolute inset-0 bg-white animate-pulse opacity-70 pointer-events-none"></div>
//             )}

//             <div className="absolute inset-0">
//                 {isWeb && (
//                     <video
//                         ref={videoRef}
//                         className="w-full h-full object-cover"
//                         autoPlay
//                         playsInline
//                         style={{ transform: 'scaleX(-1)' }}
//                     />
//                 )}
//             </div>

//             <div className="pt-4 px-4 flex justify-start z-10">
//                 <ChevronLeft
//                     className="w-8 h-8 text-white cursor-pointer"
//                     onClick={() => navigate('/kycid')}
//                 />
//             </div>

//             <div className="flex-1 flex justify-center items-center relative z-10">
//                 <div className="relative w-[80vw] h-[85vw] max-w-[350px] max-h-[400px]">

//                     <div className="absolute inset-0 border border-white/20 rounded-xl"></div>

//                     <div className="absolute top-0 left-0 w-10 h-10 border-t-4 border-l-4 border-white rounded-tl-xl"></div>
//                     <div className="absolute top-0 right-0 w-10 h-10 border-t-4 border-r-4 border-white rounded-tr-xl"></div>
//                     <div className="absolute bottom-0 left-0 w-10 h-10 border-b-4 border-l-4 border-white rounded-bl-xl"></div>
//                     <div className="absolute bottom-0 right-0 w-10 h-10 border-b-4 border-r-4 border-white rounded-br-xl"></div>
//                 </div>
//             </div>

//             <div className="px-8 pb-12 bg-gradient-to-t from-black/90 to-transparent text-center z-10">

//                 <p className="text-xl font-semibold text-white mb-2 drop-shadow-lg">
//                     Align your face in the middle
//                 </p>
//                 <p className="text-sm text-gray-300 drop-shadow-md">
//                     Make sure your face is inside the box and capture a photo
//                 </p>

//                 <div className="relative flex justify-center items-center mt-12">
//                     <button
//                         className={`w-16 h-16 bg-white rounded-full border-4 border-gray-400/40 flex items-center justify-center shadow-xl transition-transform ${
//                             isCameraActive ? "hover:scale-105" : "opacity-40"
//                         }`}
//                         onClick={handleCapture}
//                         disabled={!isCameraActive}
//                     >
//                         <div className="w-12 h-12 bg-white rounded-full border border-gray-200"></div>
//                     </button>

//                     <div className="absolute right-0">
//                         <Zap
//                             onClick={triggerFlash}
//                             className="w-7 h-7 text-white cursor-pointer hover:text-yellow-300 transition"
//                         />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SelfieCaptureScreen;



// --new test cam ---

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Zap } from "lucide-react";
import { Capacitor } from "@capacitor/core";
import { CameraPreview } from "@capacitor-community/camera-preview";

const SelfieCaptureScreen = ({ onCapture }) => {
    const navigate = useNavigate();

    const [isCameraActive, setIsCameraActive] = useState(false);
    const [flash, setFlash] = useState(false);
    const [flashEffect, setFlashEffect] = useState(false);
    const videoRef = useRef(null); // to reference the video element
    const streamRef = useRef(null);

    /* ------------------ Flash animation ------------------ */
    const triggerFlash = () => {
        setFlashEffect(true);
        setTimeout(() => setFlashEffect(false), 200);
    };

    const isWeb = Capacitor.getPlatform() === "web";

    useEffect(() => {
        const isWeb = Capacitor.getPlatform() === "web";

        const startPreview = async () => {
            if (isWeb) {
                try {
                    const mediaStream = await navigator.mediaDevices.getUserMedia({
                        video: { facingMode: 'user' }
                    });

                    // ✅ Store the stream in the Ref
                    streamRef.current = mediaStream;

                    if (videoRef.current) {
                        videoRef.current.srcObject = mediaStream;
                        videoRef.current.play();
                    }
                    setIsCameraActive(true);
                } catch (err) {
                    console.log("Web camera error", err);
                }
            }
            // Native Camera Preview Access (for iOS/Android)
            try {
                await CameraPreview.start({
                    position: "front",
                    toBack: true,
                    parent: "kyc-camera-bg",
                });
                setIsCameraActive(true);
            } catch (err) {
                console.log("Native camera preview start error", err);
            }
        };

        startPreview();

        // Cleanup for native
        return () => {
            if (!isWeb) {
                CameraPreview.stop();
            }
            // ✅ Use the Ref for cleanup
            else if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
                streamRef.current = null;
            }

        };
    }, []);
    /* ------------------ Capture Handler ------------------ */
    // const handleCapture = async () => {
    //     if (!isCameraActive) return;

    //     triggerFlash();

    //     try {
    //         const result = await CameraPreview.capture({
    //             quality: 90
    //         });

    //         const img = `data:image/jpeg;base64,${result.value}`;
    //         onCapture(img);

    //     } catch (err) {
    //         console.log("capture error", err);
    //     }
    // };

    
    /* ------------------ Capture Handler ------------------ */
const handleCapture = async () => {
    if (!isCameraActive) return;

    triggerFlash();

    if (isWeb) {
        // --- WEB CAPTURE (Using Canvas) ---
        if (!videoRef.current) return;
        
        const canvas = document.createElement('canvas');
        // Set canvas dimensions to match video stream
        canvas.width = videoRef.current.videoWidth;
        canvas.height = videoRef.current.videoHeight;

        const ctx = canvas.getContext('2d');
        // Draw the current frame from the video element onto the canvas
        ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

        // Get the image data URL
        const dataURL = canvas.toDataURL('image/jpeg', 0.9);
        onCapture(dataURL);
        
        // Cleanup the temporary canvas
        canvas.remove();

    } else {
        // --- NATIVE CAPTURE (Using Capacitor Plugin) ---
        try {
            const result = await CameraPreview.capture({
                quality: 90
            });

            const img = `data:image/jpeg;base64,${result.value}`;
            onCapture(img);

        } catch (err) {
            console.log("Native capture error:", err);
            // Consider showing an alert or error message to the user
        }
    }
};
const mainContainerClasses = `fixed inset-0 flex flex-col z-50 overflow-hidden ${isWeb ? 'bg-black' : 'bg-transparent'
        }`;

    /* ------------------ UI (unchanged) ------------------ */
    return (
        <div className={mainContainerClasses}>


            {/* FLASH EFFECT OVERLAY */}
            {flashEffect && (
                <div className="absolute inset-0 bg-white animate-pulse opacity-70 pointer-events-none"></div>
            )}

            {/* ---- This DIV is where camera preview goes ---- */}
            <div id="kyc-camera-bg" className="absolute inset-0">
                {Capacitor.getPlatform() === "web" && (
                    <video
                        ref={videoRef}
                        autoPlay
                        playsInline
                        className="w-full h-full object-cover" // Ensure it covers the background
                    />
                )}
            </div>

            <div className="pt-4 px-4 flex justify-start z-10">
                <ChevronLeft
                    className="w-8 h-8 text-white cursor-pointer"
                    onClick={() => navigate('/kycid')}
                />
            </div>

            <div className="flex-1 flex justify-center items-center relative z-10">
                <div className="relative w-[80vw] h-[85vw] max-w-[350px] max-h-[400px]">

                    <div className="absolute inset-0 border border-white/20 rounded-xl"></div>

                    <div className="absolute top-0 left-0 w-10 h-10 border-t-4 border-l-4 border-white rounded-tl-xl"></div>
                    <div className="absolute top-0 right-0 w-10 h-10 border-t-4 border-r-4 border-white rounded-tr-xl"></div>
                    <div className="absolute bottom-0 left-0 w-10 h-10 border-b-4 border-l-4 border-white rounded-bl-xl"></div>
                    <div className="absolute bottom-0 right-0 w-10 h-10 border-b-4 border-r-4 border-white rounded-br-xl"></div>
                </div>
            </div>

            <div className="px-8 pb-12 bg-gradient-to-t from-black/90 to-transparent text-center z-10">

                <p className="text-xl font-semibold text-white mb-2 drop-shadow-lg">
                    Align your face in the middle
                </p>
                <p className="text-sm text-gray-300 drop-shadow-md">
                    Make sure your face is inside the box and capture a photo
                </p>

                <div className="relative flex justify-center items-center mt-12">
                    <button
                        className={`w-16 h-16 bg-white rounded-full border-4 border-gray-400/40 flex items-center justify-center shadow-xl transition-transform ${isCameraActive ? "hover:scale-105" : "opacity-40"
                            }`}
                        onClick={handleCapture}
                        disabled={!isCameraActive}
                    >
                        <div className="w-12 h-12 bg-white rounded-full border border-gray-200"></div>
                    </button>

                    <div className="absolute right-0">
                        <Zap
                            onClick={triggerFlash}
                            className="w-7 h-7 text-white cursor-pointer hover:text-yellow-300 transition"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelfieCaptureScreen;



/* ------------------ Start Camera (native inline preview) ------------------ */
// useEffect(() => {
//     const startPreview = async () => {
//         const isWeb = Capacitor.getPlatform() === "web";

//         if (isWeb) return; // web keeps your old video UI

//         try {
//             await CameraPreview.start({
//                 position: "front",
//                 toBack: true,   // IMPORTANT: preview behind UI
//                 parent: "kyc-camera-bg",
//             });

//             setIsCameraActive(true);
//         } catch (err) {
//             console.log("Camera preview start error", err);
//         }
//     };

//     startPreview();

//     return () => {
//         CameraPreview.stop();
//     };
// }, []);